import * as React from "react";
import Section from "../form/Section";
import Row from "../form/Row";
import FormDialog from "../dialog/FormDialog";
import {useIntl} from "react-intl";
import Warning from "../presentational/Warning";

type Props = {
    attributeName: string;
    attributeLabel: string;
    onConfirm: () => void;
    handleCloseDialog: () => {};
}

const DeleteContactAttributeDialog: React.FC<Props> = ({attributeName, attributeLabel, onConfirm, handleCloseDialog}) => {
    const intl = useIntl();

    const handleSubmission = () => {
        onConfirm();
        handleCloseDialog();
    };

    const initialValues = {
        attributeName: attributeName
    };

    return (
        <FormDialog 
            handleCloseDialog={handleCloseDialog}
            handleSubmission={handleSubmission}
            initialValues={initialValues}
            headline={intl.formatMessage({id: 'contact.attributes.deleteAttribute'})}
            submitLabel={intl.formatMessage({id: 'button.delete'})}
            dangerous={true}
        >
            <Section>
                <Row>
                    <p className="text-gray-900 font-medium">
                        {intl.formatMessage({id: 'contact.attributes.confirmDelete'})}
                    </p>
                    <p className="text-gray-700 mt-2">
                        <strong>{attributeLabel}</strong> ({attributeName})
                    </p>
                </Row>
                <Row>
                    <Warning>
                        {intl.formatMessage({id: 'dialog.DeleteContactAttributeDialog.warning'})}
                    </Warning>
                </Row>
            </Section>
        </FormDialog>
    );
};

export default DeleteContactAttributeDialog;